var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoEmail = function SvgVideoEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.75 4A1.75 1.75 0 0 0 2 5.75v1.04l9.888 4.975a.25.25 0 0 0 .224 0L22 6.789V5.75A1.75 1.75 0 0 0 20.25 4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m22 8.469-9.213 4.635a1.75 1.75 0 0 1-1.574 0L2 8.47v9.78c0 .967.784 1.75 1.75 1.75h16.5A1.75 1.75 0 0 0 22 18.25z"
  })));
};
export default SvgVideoEmail;